import { Spinner } from '@nike/eds';
import { match, Default as _ } from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getNposValue } from '../../../../redux/selectors';
import { NPOS } from '../../../../utils/constants';

function NoResults({ errorMessage, translations }) {
  const {
 fetchingCompleted, doInitialLoad, isHomePage, isStoreSwitched
} = useSelector(getNposValue);
  const getMessage = useCallback(() => {
    if (errorMessage) {
      return <p className="eds-type--title-2" data-testid="no-results-error-message">{translations[NPOS.MESSAGES.FETCH_ERROR]}</p>;
    }
    if (isStoreSwitched) return <p />;

    return fetchingCompleted ? <p className="eds-type--title-2" data-testid="no-results-error-message">{translations[isHomePage ? NPOS.MESSAGES.NO_RECENT_TRANSACTIONS : NPOS.MESSAGES.NO_RESULTS]}</p> : <></>;
  }, [fetchingCompleted, isHomePage, isStoreSwitched, errorMessage, translations]);

  const getDescription = useCallback(() => {
    if (errorMessage) {
      return <p className="eds-type--body-1 eds-color--danger" data-testid="no-results-error-description">Error: {errorMessage}</p>;
    }

    const description = match()(
      [() => (isHomePage && fetchingCompleted) || isStoreSwitched, translations[NPOS.MESSAGES.SEARCH_TRANSACTIONS]],
      [() => !fetchingCompleted, translations[NPOS.MESSAGES.ADJUST_FILTERS_AND_SEARCH]],
      [() => !isHomePage, translations[NPOS.MESSAGES.ADJUST_FILTERS]],
      [_, null]
    );

    return (
      <p className="eds-type--body-1 eds-color--secondary" data-testid="no-results-error-description">
        {description}
      </p>
    );
  }, [errorMessage, fetchingCompleted, isHomePage, isStoreSwitched, translations]);

  return (
    <div className="d-sm-flx flx-dir-sm-c flx-jc-sm-c flx-ai-sm-c" style={{ gap: '12px', height: '50vh' }}>
      {doInitialLoad
      ? <Spinner size="large" /> : (
        <>
          <div>
            {getMessage()}
          </div>
          <div>
            {getDescription()}
          </div>
        </>
      )}
    </div>
  );
}

NoResults.defaultProps = {
  errorMessage: null
};

NoResults.propTypes = {
  errorMessage: PropTypes.string,
  translations: PropTypes.shape().isRequired
};

export default NoResults;
